const TokenKey = "Admin-Token";

export function getToken() {
  return localStorage.getItem(TokenKey);
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token);
}

export function removeToken() {
  return localStorage.removeItem(TokenKey);
}

/**
 * 验证token是否有效
 * @param {string} token - 要验证的token
 * @returns {boolean} - token是否有效
 */
export function isValidToken(token) {
  if (!token) {
    return false;
  }

  try {
    // 检查token格式（JWT格式：header.payload.signature）
    const parts = token.split(".");
    if (parts.length !== 3) {
      return false;
    }

    // 解析payload部分
    const payload = JSON.parse(atob(parts[1]));

    // 检查过期时间
    if (payload.exp) {
      const currentTime = Math.floor(Date.now() / 1000);
      if (currentTime >= payload.exp) {
        return false;
      }
    }

    return true;
  } catch (error) {
    // Token解析失败
    return false;
  }
}

/**
 * 获取token的剩余有效时间（秒）
 * @param {string} token - 要检查的token
 * @returns {number} - 剩余有效时间（秒），如果无效返回0
 */
export function getTokenRemainingTime(token) {
  if (!token) {
    return 0;
  }

  try {
    const parts = token.split(".");
    if (parts.length !== 3) {
      return 0;
    }

    const payload = JSON.parse(atob(parts[1]));
    if (!payload.exp) {
      return 0;
    }

    const currentTime = Math.floor(Date.now() / 1000);
    const remainingTime = payload.exp - currentTime;

    return remainingTime > 0 ? remainingTime : 0;
  } catch (error) {
    // Token解析失败
    return 0;
  }
}

/**
 * 检查当前存储的token是否有效
 * @returns {boolean} - 当前token是否有效
 */
export function isCurrentTokenValid() {
  const token = getToken();
  return isValidToken(token);
}

/**
 * 检查token是否需要刷新（剩余时间少于5分钟）
 * @param {string} token - 要检查的token
 * @returns {boolean} - 是否需要刷新
 */
export function shouldRefreshToken(token) {
  const remainingTime = getTokenRemainingTime(token);
  // 如果剩余时间少于5分钟（300秒），则需要刷新
  return remainingTime > 0 && remainingTime < 300;
}

/**
 * 检查当前token是否需要刷新
 * @returns {boolean} - 当前token是否需要刷新
 */
export function shouldRefreshCurrentToken() {
  const token = getToken();
  return shouldRefreshToken(token);
}
